// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"494":"a30d3b4cf0ffc7dcac72","656":"7507e3963aab278f4d74"}[chunkId] + ".css";
};